import styled from 'styled-components'
import { theme } from '../../styles'

export const Root = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 13px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  color: ${theme.cores.white};
  cursor: ${( { $interactive } ) => ( $interactive ? 'pointer' : 'default' )};
  text-align: left;
  transition: background 0.2s ease, border-color 0.2s ease;
  font-family: inherit;

  &:disabled {
    opacity: 1;
  }

  ${( { $interactive } ) => ( $interactive
    ? `&:hover {
        background: rgba(255, 255, 255, 0.14);
        border-color: rgba(255, 255, 255, 0.28);
      }`
    : '' )}

  ${( { $danger, $interactive } ) => ( $danger
    ? `${$interactive ? '&:hover { border-color: rgba(240, 144, 137, 0.5); }' : ''}`
    : '' )}

  ${( { $primary } ) => ( $primary
    ? `background: ${theme.cores.accent};
       border-color: ${theme.cores.accent};
       color: ${theme.cores.white};
       box-shadow: 0 6px 18px rgba(213, 112, 27, 0.32);
       &:hover {
         background: #C56415;
         border-color: #C56415;
       }`
    : '' )}

  ${( { $done } ) => ( $done
    ? `background: rgba(90, 170, 120, 0.14);
       border-color: rgba(90, 170, 120, 0.4);
       cursor: default;`
    : '' )}

  ${theme.mobile} {
    padding: 14px;
    min-height: 56px;
    border-radius: 14px;
  }
`

export const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: ${( { $primary, $danger, $done } ) => {
    if ( $primary ) {
      return 'rgba(255, 255, 255, 0.22)'
    }
    if ( $done ) {
      return 'rgba(90, 170, 120, 0.22)'
    }
    if ( $danger ) {
      return 'rgba(240, 144, 137, 0.16)'
    }
    return 'rgba(232, 154, 79, 0.18)'
  }};
  color: ${( { $primary, $danger, $done } ) => {
    if ( $primary ) {
      return theme.cores.white
    }
    if ( $done ) {
      return '#8FD6A8'
    }
    if ( $danger ) {
      return '#F0928B'
    }
    return theme.cores.accentSoft
  }};

  svg {
    width: 19px;
    height: 19px;
  }

  ${theme.mobile} {
    width: 40px;
    height: 40px;
  }
`

export const Body = styled.span`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
`

export const Title = styled.span`
  font-size: 15px;
  font-weight: 600;

  ${theme.mobile} {
    font-size: 15px;
  }
`

export const Meta = styled.span`
  font-size: 12px;
  color: ${theme.cores.whiteAlpha70};

  ${theme.mobile} {
    font-size: 12.5px;
  }
`

export const MetaDica = styled.span`
  color: ${theme.cores.whiteAlpha40};
`

export const ArrowWrap = styled.span`
  display: inline-flex;
  color: ${( { $done } ) => ( $done ? '#8FD6A8' : theme.cores.whiteAlpha60 )};
`
